import { useMemo } from "react";

import { useDataLayerQuery } from "#/hooks/useDataLayer";
import { BreedingValuesKodaIzracunService } from "#/pages/breeding-values/BreedingValuesKodaIzracunService";

/**
 * Custom hook for Breeding Values Koda izracun Query.
 * Uses the BreedingValuesComparisonRankService to perform POST queries.
 *
 * @returns {object} The data layer query object (result, isLoading, error, query, reload).
 */
export function useBreedingValuesKodaIzracunQuery() {
  const service = useMemo(() => new BreedingValuesKodaIzracunService(), []);

  return useDataLayerQuery({
    ident: "breeding-values-koda-izracun",
    dataLayer: service,
  });
}
